import { Pipe, PipeTransform } from '@angular/core';

/**
 * Angular pipe to format numbers as billions ('B'), millions ('M') or thousands ('K').
 * Handles null, undefined, negative, and non-numeric inputs gracefully.
 * Usage: {{ value | BillionsToBMillionsToMThousandsToK }}
 */
@Pipe({ name: 'BillionsToBMillionsToMThousandsToK' })
export class BillionsToBMillionsToMThousandsToK implements PipeTransform {
  
  /**
   * Helper function to add commas to a number string for US formatting
   * @param numStr - The number string to format
   * @returns The formatted string with commas
   */
  private addCommas(numStr: string): string {
    const parts = numStr.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }

  transform(value: number | null | undefined, keepOneDecimal: boolean = false): string {
    if (value == null || typeof value !== 'number' || isNaN(value)) return '0';

    const abs = Math.abs(value);
    
    if (abs < 1000) {
      return this.addCommas(value.toString());
    }
    if (abs < 1_000_000) {
      const kValue = keepOneDecimal
        ? (value / 1_000).toFixed(1)
        : (value / 1_000).toFixed(1).replace(/\.0$/, '');
      return this.addCommas(kValue) + 'K';
    }
    if (abs < 1_000_000_000) {
      const mValue = keepOneDecimal
        ? (value / 1_000_000).toFixed(1)
        : (value / 1_000_000).toFixed(1).replace(/\.0$/, '');
      return this.addCommas(mValue) + 'M';
    }
    const bValue = keepOneDecimal
      ? (value / 1_000_000_000).toFixed(1)
      : (value / 1_000_000_000).toFixed(1).replace(/\.0$/, '');
    return this.addCommas(bValue) + 'B';
  }
}